import { css } from "@emotion/react";
import React, { forwardRef } from "react";
export const CalendarUIContainer = forwardRef<
  HTMLDivElement,
  {
    /**
     * 元々かなり大きいコンポーネントのため、`"large"`サイズはサポートしません。
     * @default "medium"
     */
    size?: "small" | "medium";
    children?: React.ReactNode;
  }
>(({ size = "medium", ...props }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      css={css`
        max-width: ${size === "small" ? "350px" : undefined};
      `}
    />
  );
});
